import { createContext, useContext, useState, useEffect, ReactNode } from "react";
import { useIsTablet } from "@/hooks/use-tablet";

interface TabletSidebarContextType {
  isCollapsed: boolean;
  toggleSidebar: () => void;
  sidebarWidth: number;
}

const TabletSidebarContext = createContext<TabletSidebarContextType>({
  isCollapsed: true,
  toggleSidebar: () => {},
  sidebarWidth: 64,
});

export const useTabletSidebar = () => useContext(TabletSidebarContext);

interface TabletSidebarProviderProps {
  children: ReactNode;
}

export const TabletSidebarProvider = ({ children }: TabletSidebarProviderProps) => {
  const [isCollapsed, setIsCollapsed] = useState(true);
  const isTablet = useIsTablet();

  // Auto-collapse on tablet for more content space
  useEffect(() => {
    if (isTablet) {
      setIsCollapsed(true);
    }
  }, [isTablet]);

  const toggleSidebar = () => {
    setIsCollapsed(prev => !prev);
  };

  // Calculate sidebar width: 64px (w-16) collapsed, 224px (w-56) expanded
  const sidebarWidth = isTablet ? (isCollapsed ? 64 : 224) : 0;

  return (
    <TabletSidebarContext.Provider value={{ isCollapsed, toggleSidebar, sidebarWidth }}>
      {children}
    </TabletSidebarContext.Provider>
  );
};
